export default __webpack_public_path__ + "static/media/5.878de0bb.png";